import type { NetworkNode } from '@/types'

export const publicNetworks: NetworkNode[] = [
  { name: 'TokenPocket', rpc: 'https://eospush.mytokenpocket.vip', check: true },
  { name: 'Greymass', rpc: 'https://eos.greymass.com' },
  { name: 'EOS Nation', rpc: 'https://eos.eosn.io' },
  { name: 'EOS sw/eden', rpc: 'https://api.eossweden.org' },
]

export const testNetworks: NetworkNode[] = [
  { name: 'TTR Net', rpc: 'http://office.gogo8899.com:8888' },
]

export const eosChainId = 'aca376f206b8fc25a6ed44dbdc66547c36c6c33e3a119ffbeaef943642f0e906'
export const ttrChainId = '8a34ec7df1b8cd06ff4a8abbaa7cc50300823350cadc59ab296cb00d104d2b8f'

export function isTestNetwork(rpc: string): boolean {
  return testNetworks.some((n) => n.rpc === rpc)
}

export function getChainId(rpc: string): string {
  return isTestNetwork(rpc) ? ttrChainId : eosChainId
}
